// @ts-check
import axios from 'axios';

const axiosInstance = axios.create();

/** @type {ReturnType<typeof setTimeout> | null} */
let refreshTimer;

/**
 * Refreshes the JWT and schedules the next refresh from its `expires_in`.
 *
 * @returns {Promise<void>}
 */
const refreshToken = async () => {
  const result = await axiosInstance.post(`${process.env.REACT_APP_CLOUD_CONNECT_API}/refreshToken`, {}, { headers: { Authorization: `Bearer ${localStorage.getItem('JWT_TOKEN')}`}});

  localStorage.setItem('JWT_TOKEN', result.data.access_token);

  setupRefreshTimer(result.data.expires_in);
}

/**
 * Schedules the next refresh 20s before expiry, replacing any pending timer.
 *
 * @param {number} refreshTime Token lifetime in seconds (`expires_in`).
 * @returns {void}
 */
const setupRefreshTimer = (refreshTime) => {
  cancelRefreshTimer();

  const timeout = refreshTime < 20 ? 20 : refreshTime - 20;

  refreshTimer = setTimeout(async () => {
    await refreshToken();
  }, (timeout) * 1000);
}

/**
 * Clears the pending refresh timer, if one is scheduled.
 *
 * @returns {void}
 */
const cancelRefreshTimer = () => {
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
}

/**
 * Fetches the logged-in user. Returns the full axios response (read `.data`).
 *
 * @returns {Promise<import('axios').AxiosResponse<any>>}
 */
const getLoggedUserInfo = async () => {
  const headers = { Authorization: `Bearer ${localStorage.getItem('JWT_TOKEN')}`, "content-type": "application/json"};
  const time = Date.now();

  const me = await axiosInstance.get(`${process.env.REACT_APP_CLOUD_CONNECT_API}/me?_=${time}`, { headers });

  return me;
}

const authService = {
  refreshToken,
  setupRefreshTimer,
  cancelRefreshTimer,
  getLoggedUserInfo,
};

export default authService;
